// DS: i5.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Lock: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        d="M11 4a3 3 0 00-6 0v2H3a1 1 0 00-1 1v7a1 1 0 001 1h10a1 1 0 001-1V7a1 1 0 00-1-1h-2V4zm-7 9V8h8v5H4zm4-4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zm-.993-5.117A1 1 0 018 3l.117.007A1 1 0 019 4v2H7V4l.007-.117z"
        clipRule="evenodd"
      ></path>
    </svg>
  </IconWrap>
);
Lock.displayName = 'Lock';

export default Lock;
